export default "__VITE_ASSET__BSdbrq0T__"